export { default } from "./EventCard";
